import request from './request'

// 投票任务列表
export function getVoteTaskList (params) {
  return request({
    url: '/admin/vote/task/list',
    method: 'get',
    params
  })
}

// 创建投票任务
export function createVoteTask (data) {
  return request({
    url: '/admin/vote/task/create',
    method: 'post',
    data
  })
}

// 创建投票任务预览
export function previewVoteTask (data) {
  return request({
    url: '/admin/vote/task/preview',
    method: 'post',
    data
  })
}

// 投票任务详情
export function getVoteTaskDetail (id) {
  return request({
    url: `/admin/vote/task/detail/${id}`,
    method: 'get'
  })
}

// 投票进度统计
export function getVoteTaskStat (id) {
  return request({
    url: `/admin/vote/task/stat/${id}`,
    method: 'get'
  })
}

// 投票结果计算
export function getVoteTaskResult (id) {
  return request({
    url: `/admin/vote/task/result/${id}`,
    method: 'get'
  })
}

// 投票统计详情（含明细与匿名标识）
export function getVoteTaskStatDetail (id) {
  return request({
    url: `/admin/vote/task/stat/detail/${id}`,
    method: 'get'
  })
}

// 提前结束投票
export function endVoteTask (id) {
  return request({
    url: `/admin/vote/task/end/${id}`,
    method: 'put'
  })
}

// 投票任务参与人列表
export function getVoteTaskPartners (id, params) {
  return request({
    url: `/admin/vote/task/partners/${id}`,
    method: 'get',
    params
  })
}

// 新增投票任务参与人
export function addVoteTaskPartner (id, partnerId) {
  return request({
    url: `/admin/vote/task/partners/${id}`,
    method: 'post',
    params: { partnerId }
  })
}

// 委托管理列表
export function getDelegateList (params) {
  return request({
    url: '/admin/vote/task/delegate/list',
    method: 'get',
    params
  })
}

// 创建委托
export function createDelegate (data) {
  return request({
    url: '/admin/vote/task/delegate/create',
    method: 'post',
    data
  })
}

// 导出投票结果
export function exportVoteResult (voteTaskId) {
  return request({
    url: `/admin/vote/result/export/${voteTaskId}`,
    method: 'get',
    responseType: 'blob'
  })
}

// 修改投票任务开始时间
export function updateVoteTaskStartTime (data) {
  return request({
    url: '/admin/vote/task/start-time',
    method: 'put',
    data
  })
}
